import type { MenuItem } from '../model/types';

export const getMenuItems = (cityAlias: string = 'almaty'): MenuItem[] => {
  const baseTranslate = 'shared.footer';

  return [
    { name: `${baseTranslate}.doctors`, href: `/${cityAlias}/doctors` },
    { name: `${baseTranslate}.medcenters`, href: `/${cityAlias}/medcenters` },
    { name: `${baseTranslate}.services`, href: `/${cityAlias}/services` },
    { name: `${baseTranslate}.treatment`, href: `/${cityAlias}/lechenie` },
  ];
};
